import { setLoader, unSetLoader, setErrorMessage } from "../appActions";
import { billing } from "store/requests";
import { openFileInWindow } from "utils/helper";

export const getPatientFormList = (payload) => {
  return async (dispatch) => {
    try {
      dispatch(setLoader());
      let { data } = await billing({
        url: "/getPatientFormList",
        payload,
        addUserName: true,
      });
      return data;
    } catch (error) {
      dispatch(setErrorMessage(error?.response?.data?.error || error.message));
    } finally {
      dispatch(unSetLoader());
    }
  };
};

// export const getChargeLineTransactions = async (payload) => {
//   try {
//     let { data } = await billing({
//       url: "/getChargeLineTransactions",
//       payload,
//     });
//     return data;
//   } catch (error) {
//     console.error(error);
//   }
// };

export const getFormType = (payload) => {
  return async (dispatch) => {
    try {
      dispatch(setLoader());
      let { data } = await billing({
        url: "/getFormType",
        payload,
        addUserName: true,
      });
      return data;
    } catch (error) {
      dispatch(setErrorMessage(error?.response?.data?.error || error.message));
    } finally {
      dispatch(unSetLoader());
    }
  };
};

export const getForms = (payload) => {
  return async (dispatch) => {
    try {
      let { data } = await billing({
        url: "/getForms",
        payload,
        addUserName: true,
      });
      return data;
    } catch (error) {
      dispatch(setErrorMessage(error?.response?.data?.error || error.message));
    }
  };
};

export const viewFormPdf = (payload) => {
  return async (dispatch) => {
    try {
      let response = await billing({
        url: "/viewFormPdf",
        payload,
        addUserName: true,
        data: {
          responseType: "blob",
        },
      });
      openFileInWindow({
        response,
        ext: "pdf",
      });
    } catch (error) {
      dispatch(setErrorMessage(error?.response?.data?.error || error.message));
    }
  };
};

export const saveForm = (payload) => {
  return async (dispatch) => {
    try {
      dispatch(setLoader());
      let { data } = await billing({
        url: "/saveForm",
        payload,
        addUserName: true,
      });
      return data;
    } catch (error) {
      dispatch(setErrorMessage(error?.response?.data?.error || error.message));
    } finally {
      dispatch(unSetLoader());
    }
  };
};
